<div class="modal inmodal fade show" style="display: block; padding-right: 15px;">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" data-dismiss="modal" (click)="close()">
					<span aria-hidden="true">×</span>
					<span class="sr-only">Close</span>
				</button>
				<h4 class="modal-title">Image Cropper</h4>
			</div>
			<div class="modal-body">

				<div class="container" style="min-height: 500px;">

					<div class="row" style="margin: 0 auto">
						<div class="col-9">
							<angular-cropper #angularCropper (change)="crop()"
									[cropperOptions]="config" (ready)="doReady()"
									[imageUrl]="imageToCrop" (export)="crop()"></angular-cropper>

							<div class="row mt-2">
								<div class="col-lg-8">
									<!--								<button class="btn btn-primary btn-sm me-1" (click)="setRatio(16/3)">16/3</button>-->
									<!--								<button class="btn btn-primary btn-sm me-1" (click)="setRatio(16/4)">16/4</button>-->
									<!--								<button class="btn btn-primary btn-sm me-1" (click)="setRatio(16/5)">16/5</button>-->
									<button class="btn btn-primary btn-sm me-1" (click)="setRatio(16/6)">Banner image</button>
									<!--								<button class="btn btn-primary btn-sm me-1" (click)="setRatio(16/7)">16/7</button>-->
									<button class="btn btn-primary btn-sm me-1" (click)="setRatio(4/3)">Category tile</button>
									<!--								<button class="btn btn-primary btn-sm me-1" (click)="setRatio(4/2)">4/2</button>-->
									<!--								<button class="btn btn-primary btn-sm me-1" (click)="setRatio(4/1)">4/1</button>-->
									<button class="btn btn-primary btn-sm me-1" (click)="setRatio(1/1)">Logo</button>
									<button class="btn btn-primary btn-sm me-1" (click)="setRatio('NaN')">Free Size</button>
									<button class="btn btn-primary btn-sm me-1" (click)="rotate()">Rotate</button>
									<button class="btn btn-primary btn-sm me-1" (click)="reset()">Reset</button>
								</div>
								<div class="col-lg-4 text-end">
<!--									<button class="btn btn-primary btn-sm" (click)="crop()">Crop</button>-->
								</div>
							</div>
						</div>
						<div class="col-3">
							<div class="row">
								<div class="col-12">
									<img [src]="croppedImage" class="img-fluid" />
								</div>
								<div class="col-12 text-end">
									<button class="btn btn-primary mt-3" (click)="save()">Save Changes</button>
								</div>
							</div>

						</div>
					</div>

				</div>
			</div>

        </div>
    </div>
</div>
